import React from 'react';
import PropTypes from 'prop-types';
import css from './UtilitaryLink.css';
import { pathToLink, activeColor } from '../utils/menuOptions';
import { camelCase } from 'lodash';

export default class UtilitaryLink extends React.Component {

  get isActive() {
    return this.props.path === `${window.location.pathname.split("/").slice(2).join("/")}${window.location.search}`;
  }

  render() {
    return (
      <li
        className={css['utilitary-link']}
        style={{backgroundColor: this.isActive && !this.props.currentSection ? activeColor : null}}
        id= {camelCase("nav " + this.props.label)}>
        <a href={pathToLink(this.props.path)}>
            {this.props.label}
        </a>
      </li>
    );
  }
}

UtilitaryLink.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  currentSection: PropTypes.string
};
